import {CurrencyAmount} from 'util/currency';

export enum ProductSKU {
  SpaceRental = 'hour_booking_01',
  Staff = 'staff',
  Chairs = 'chairs',
  Tables = 'tables',
  StorageBoxes = 'storage-boxes',
  FlexiTicket = 'flexi-ticket'
}

export enum ProductCategory {
  Bookings = 'bookings',
  Staff = 'staff',
  Furniture = 'furniture',
  Storage = 'storage',
  FlexiTicket = 'flexi-ticket'
}

export enum ProductOptionCode {
  Configuration = 'configuration',
  HoursBefore = 'hours-before',
  HoursAfter = 'hours-after',
  DaysBefore = 'days-before',
  DaysAfter = 'days-after',
}

export interface ProductOptionValue {
  name: string;
  code: string;
  image: string|null;
  description: string|null;
}

export interface ProductOption {
  name: string;
  code: string;
  values: ProductOptionValue[];
}

export interface Product {
  sku: string;
  name: string;
  category: ProductCategory;
  description: string|null;
  image: string|null;
  maxQuantity: number;
  prices: CurrencyAmount[];
  options: ProductOption[];
}